import { hardenCookies } from '@wix/client-security'
import { buildExpiredSessionCookie, readCookie } from './helpers'
import { clearReload, handleBrowserCache } from './browser-cache-handling'
import { isExperimentOpen } from '@wix/thunderbolt-experiments'

const CLIENT_COOKIE_NAME = 'client-session-bind'
const CLIENT_HEADER = 'client-binding'
const SEC_FETCH_UNSUPPORTED_COOKIE = 'sec-fetch-unsupported'
const BROWSER_CACHE_RELOAD_EXPERIMENT = 'specs.thunderbolt.browserCacheReload'

// @ts-expect-error
const { experiments } = window.viewerModel

const deniedCookieNames = [
	CLIENT_COOKIE_NAME,
	CLIENT_HEADER, // adding this for precaution when hardening cookies
	SEC_FETCH_UNSUPPORTED_COOKIE,
	'svSession',
	'smSession',
	'server-session-bind',
	'wixSession2',
	'wixSession3',
].map((cookieName) => cookieName.toLowerCase())

export const { cookie } = hardenCookies(deniedCookieNames)

export const removeSessionCookie = () => {
	const cookieParamsNoDomain = buildExpiredSessionCookie(CLIENT_COOKIE_NAME)
	const cookieParams = buildExpiredSessionCookie(CLIENT_COOKIE_NAME, location.hostname)
	// This removes cookies set after we made the switch to the new model of writing cookies without domain (for Fastly)
	cookie!.set!.call(document, cookieParamsNoDomain)
	// This removes cookies set with domain
	cookie!.set!.call(document, cookieParams)
}

export const getAndDeleteClientSessionValue = () => {
	const clientSessionValue = readCookie(CLIENT_COOKIE_NAME, cookie)
	// Only relevant if the experiment is enabled
	if (isExperimentOpen(experiments, BROWSER_CACHE_RELOAD_EXPERIMENT)) {
		// Check if the server / cdn did not get the sec-fetch headers
		const secFetchUnsupported = readCookie(SEC_FETCH_UNSUPPORTED_COOKIE, cookie)

		if (!secFetchUnsupported && !clientSessionValue) {
			// In these cases we don't have a client session cookie but the browser supports sec-fetch headers
			// So we are most probably in a cache flow, which will break since we can't get
			// access tokens for the site to work
			handleBrowserCache()
		} else {
			clearReload()
		}
	}
	removeSessionCookie()
	return clientSessionValue
}
